function CategoryCard({ category }) {
    return (
        <div className="px-1 flex flex-col items-center gap-1 shrink-0">
            <div className="size-[52px] rounded-full overflow-hidden">
                <img className='size-full object-cover' src={category.imageLink} alt={category.name} />
            </div>

            <p className='font-normal text-[12px] leading-6 text-[#FFFFFF]'>{category.name}</p>
        </div>
    );
}

function CategorySection({ item }) {
    return (
        <div className='w-full flex flex-col gap-3'>
            <p className='px-4 font-semibold text-[18px] leading-[26px] text-[#B0B0B0]'>{item.item.name}</p>

            <div className="px-4 flex flex-nowrap gap-2 overflow-x-scroll no-scrollbar">
                {item.item.categoryLinkList.map(category => {
                    return (
                        <CategoryCard 
                            key={category.id} 
                            category={category} 
                        />
                    );
                })}
            </div>
        </div>
    );
}

export default CategorySection;
